<template>
  <div v-loading="isLoading" class="ochart" @click="resetPosition">
    <OrgChart
      :data="chartData"
      :vue="Vue"
      :html-to-canvas="html2canvas"
      node-id="_id"
      container-class="orgchart-container"
      chart-class="departmentOchart-chart"
      common-class="fa"
      spinner-class="fa fa-circle-o-notch fa-spin spinner"
      export-btn-class
      left-arrow-class="fa-chevron-left"
      right-arrow-class="fa-chevron-right"
      up-arrow-class="fa-chevron-up"
      down-arrow-class="fa-chevron-down"
      toggle-btn-on-class="fa-plus-square"
      toggle-btn-off-class="fa-minus-square"
      parent-node-symbol-class
      :zoom="false"
      @drag="updateDataOnDrag"
    >
      <div slot-scope="{ nodeData }">
        <div id="orgdepartment"
             :class="[departmentName===nodeData.名称?'highlight':'','title company-orgdepartment-across']"
             style="overflow:unset"
             @dblclick="showDepartmentList(nodeData)"
        >
          <p class="span-maxcontent">{{ nodeData.名称 }}</p>
          <p v-if="nodeData.高管" class="span-maxcontent">{{ nodeData.高管 }}</p>
          <p v-else-if="nodeData.A角" class="span-maxcontent">{{ nodeData.A角 }}</p>
          <p class="span-maxcontent">{{ nodeData.人数 }}</p>
          <!-- <span class="span-maxcontent">
            {{ nodeData.名称 }}
            <span v-if="nodeData.高管">（{{nodeData.高管}}）</span>
            <span v-else-if="nodeData.A角">（{{nodeData.A角}}）</span>
          </span>
          <div class="depnumber">{{nodeData.人数}}</div> -->
        </div>
      </div>
    </OrgChart>
  </div>
</template>
<script>
import OrgChart from '@c42/vue-orgchart'
import Vue from 'vue'
import html2canvas from 'html2canvas'

export default {
  components: { OrgChart },
  props: {
    companyName: { type: String, default: '' },
    departmentName: { type: String, default: '' },
  },
  data() {
    return {
      Vue,
      html2canvas,
      chartData: {
        _id: 1,
        名称: '无',
        children: [],
      },
      isLoading: false,
      zIndex: '',
      ochartDataItems: [],
    }
  },
  watch: {
    companyName(newValue, oldValue) {
      if (newValue) this.loadData()
    },
    departmentName(newValue, oldValue) {
      if (newValue) {
        const nodeData = this.ochartDataItems.find(v => v.名称 === newValue)
        if (nodeData) this.resetPosition(nodeData)
      }
    },
  },
  methods: {
    initChartData() {
      this.chartData = {
        _id: 1,
        名称: '无',
        children: [],
      }
    },
    getTree(tree) {
      this.$emit('getTree', { tree, nodes: this.ochartDataItems })
    },
    resetPosition(nodeData) {
      const box = this.$el.querySelector('.departmentOchart-chart')
      if (!box) return
      const boxRect = box.getBoundingClientRect()
      const dom = box.querySelector(`#${nodeData._id}`)
      if (!dom) return
      const domRect = dom.getBoundingClientRect()
      const left = domRect.left - boxRect.left
      box.style.transform = `matrix(1, 0, 0, 1, -${left}, 0)`
    },
    showDepartmentList(nodeData) {
      this.$emit('showDepartmentList', nodeData)
    },
    async loadData() {
      // if (params) this.companyName = params.companyName
      this.isLoading = true
      const res = await app.service('company').getCompanyOchart({ 公司: this.companyName })
      if (res.status === 'success') {
        if (res.data.length !== 0) {
          this.ochartDataItems = res.data.filter(v => v.人数 && v.人数 !== 0)
          this.toTreeData(this.ochartDataItems)
        } else {
          this.$message.error('未获取到数据，请在测试小队描述此bug')
        }
      }
      this.isLoading = false
    },
    initDepartment(department) {
      if (department.inited) return department
      department.pid = department.inCompanyParentId
      const table = department.table || []
      const A = table.find(val => val.部门角色 === 'A角')
      department.A角 = A ? A.姓名 || A.人选 : null
      department.inited = true
      // element  tree组件，选择框默认不可选
      if (department.名称 === '高管' || department.名称 === '空') department.disabled = true
      return department
    },
    toTreeData(arr) {
      const tree = []
      const pos = {}
      let i = 0
      let num = 0
      const { companyName } = this
      const val = arr.map(this.initDepartment)
      while (num < 10000 && val.length !== 0) {
        num++
        const department = val[i]
        if (tree.length === 0 && department.pid === companyName) {
          department.children = []
          tree.push(department)
          pos[department._id] = [0]
          val.splice(i, 1)
          i = -1
        } else if (tree.length !== 0) {
          tree[0].children.push(department)
          pos[department._id] = [0, tree[0].children.length - 1]
          val.splice(i, 1)
          i = -1
        }
        i++
        if (i > val.length - 1) i = 0
      }
      this.getTree(tree)
      this.initOchartPosition()
      this.chartData = tree[0] || {}
      this.copyChartData = JSON.parse(JSON.stringify(this.chartData))
    },
    initOchartPosition() {
      const dom = this.$el.querySelector('.departmentOchart-chart')
      if (dom) dom.style.transform = 'matrix(1, 0, 0, 1, 0, 0)'
    },
    async updateDataOnDrag(params) {
      this.chartData = JSON.parse(JSON.stringify(this.copyChartData))
    },
  },
}
</script>
<style>
.departmentOchart-chart {
  background-color: #f3f2f2;
  padding-bottom: 20px;
  padding-right: 20px;
}
</style>
<style src='../../statistics/css/departmentOchart.css' scoped></style>
